export function useBreakpoints() {
  const windowWidth = ref<number>();

  // eslint-disable-next-line no-return-assign
  const onWidthChange = () => (windowWidth.value = window.innerWidth);
  onMounted(() => {
    onWidthChange();
    window.addEventListener('resize', onWidthChange);
  });
  onUnmounted(() => window.removeEventListener('resize', onWidthChange));

  const breakpoint = computed(() => {
    if (windowWidth.value === undefined) return undefined;
    if (windowWidth.value < 440) return '2xs';
    if (windowWidth.value >= 440 && windowWidth.value < 640) return 'xs';
    if (windowWidth.value >= 640 && windowWidth.value < 768) return 'sm';
    if (windowWidth.value >= 768 && windowWidth.value < 1024) return 'md';
    if (windowWidth.value >= 1024 && windowWidth.value < 1280) return 'lg';
    if (windowWidth.value >= 1280 && windowWidth.value < 1536) return 'xl';
    return '2xl';
  });
  const width = computed(() => windowWidth.value ?? 0);
  const isMobile = computed(() =>
    breakpoint.value === undefined ? undefined : ['2xs', 'xs', 'sm'].includes(breakpoint.value),
  );

  return { breakpoint, width, isMobile };
}
